import React from 'react';

export default function Hero() {
  const scrollToContact = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      // Rola até o elemento e adiciona um pequeno offset para garantir que está visível
      const yOffset = -80; // Ajuste para compensar a navbar fixa
      const y = contactSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen">
      {/* LCP: usa <img> com prioridade alta em vez de background-image */}
      <picture>
        <source media="(max-width: 768px)" srcSet="/images/warehouse-mobile.webp" />
        <img
          src="/images/warehouse.webp"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover"
          fetchPriority="high"
          loading="eager"
          decoding="async"
          width="1456"
          height="816"
        />
      </picture>
      {/* Overlay escuro */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Conteúdo — hierarquia: eyebrow (1 linha) → H1 → apoio → CTA; evita poluir o topo com parágrafos longos */}
      <div className="relative h-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-8">
        <div className="flex flex-col justify-center h-full pt-20 sm:pt-24 md:pt-28">
          <div className="max-w-3xl">
            <p className="mb-5 max-w-xl text-[11px] sm:text-xs font-semibold uppercase tracking-[0.18em] text-sky-300/95 [text-wrap:balance]">
              Tavares Consulting · Logística e supply chain · +20 anos · Atuação em todo o Brasil
            </p>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              <span className="block">Logística eficiente, custos reduzidos.</span>
              <span className="block text-blue-400">Consultoria especializada para sua empresa.</span>
            </h1>
            
            <p className="text-lg sm:text-xl text-gray-200 mb-8 max-w-2xl leading-relaxed">
              Otimize frete, centros de distribuição e operações com transportadoras — com tecnologia de ponta e
              atendimento personalizado. Resultados comprovados em custos e eficiência logística.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#contact"
                onClick={scrollToContact}
                className="inline-flex justify-center items-center px-6 sm:px-8 py-3 text-base font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
              >
                Quero reduzir custos agora{' '}
                <span className="ml-2">→</span>
              </a>
              <a
                href="#services"
                className="inline-flex justify-center items-center px-6 sm:px-8 py-3 text-base font-medium text-white border border-white/80 rounded-md hover:bg-white/10 transition-colors"
              >
                Conheça nossos serviços
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}